{
  "header": {
    "today": "Today",
    "backToToday": "← Back to Today",
    "notifications": "Notifications"
  },
  "readiness": {
    "ready": "READY",
    "noData": "NO DATA",
    "noDataYet": "No readiness data yet",
    "rationaleNoData": "Log HRV and sleep by hand, or connect a device to sync them.",
    "logManually": "Log HRV and sleep",
    "rationale": "Based on your overnight HRV and sleep.",
    "headlinePushToday": "Good to push today",
    "headlinePush": "Good to push",
    "headlineEasyToday": "Take it easy today",
    "headlineEasy": "Take it easy",
    "hrv": "HRV",
    "sleep": "Sleep",
    "battery": "Battery",
    "rationaleHrv": "Based on your overnight HRV.",
    "rationaleSleep": "Based on your sleep score.",
    "rationaleSleepManual": "Based on the sleep score you entered.",
    "rationaleHrvSleepManual": "Based on your overnight HRV and the sleep score you entered."
  },
  "energyBalance": {
    "title": "Energy balance",
    "setGoal": "Set goal",
    "logNutrition": "Log nutrition",
    "gatedPrompt": "Complete your athlete details to estimate energy",
    "intake": "Intake",
    "net": "Net",
    "target": "Target",
    "source": {
      "measured": "Measured",
      "predicted": "Predicted",
      "mixed": "Mixed"
    },
    "untracked": "Untracked",
    "deficit": "{{value}} kcal deficit",
    "surplus": "{{value}} kcal surplus",
    "balanced": "balanced",
    "capWarning": "Goal capped to a safe rate — adjust the target date if you want faster progress.",
    "capOverridden": "Goal exceeds the safe rate — you chose to override the cap."
  },
  "weekStrip": {
    "previousDay": "Previous day",
    "nextDay": "Next day",
    "openInCalendar": "Open week in calendar",
    "calendar": "Calendar",
    "day": {
      "today": " (today)",
      "empty": "Focus {{day}}{{today}}, nothing planned",
      "planned": "Focus {{day}}{{today}}, {{count}} planned{{intensity}}{{duration}}",
      "intensity": {
        "easy": "easy",
        "moderate": "moderate",
        "hard": "hard"
      },
      "estimated": "{{intensity}} estimated"
    }
  },
  "trends": {
    "title": "Trends"
  },
  "planned": {
    "title": "Planned",
    "emptyTitle": "Nothing planned today",
    "emptyBody": "Create a workout to fill your day.",
    "planSession": "Plan a session"
  }
}
